import React from 'react'
import PropTypes from 'prop-types'
import { Loader, Notification, Section } from "@qure/containers";
import './index.scss'

const defaultSubLabel = 'Please wait while we prepare the application just for you'

function CardLoader(props) {
  const {t, label} = props
  const CTAVisibilityTimeout= 10000

  const CTAComponent= () => (
    <Notification className="mt-4">
      <div className="mb-4">
        {t('Looks like it’s taking sometime for the page to load. Could you try logging in again?')}
      </div>
      <a href='/login?redirect=true' className='button is-primary'>
        {t('Go to login')}
      </a>
    </Notification>
  )

  const loadingText = {
    title : t('Loading'),
    subTitle : t(label)
  }

  return (
    <Section>
      <Loader
        loadingText={loadingText}
        CTAVisibilityTimeout={CTAVisibilityTimeout}
        CTAComponent={CTAComponent} />
    </Section>
  )
}

CardLoader.defaultProps = {
  label: defaultSubLabel
}
CardLoader.propTypes= {
  t: PropTypes.func.isRequired,
  label: PropTypes.string
}

export default CardLoader

